import {
  SAMPLES_REQUEST,
  SAMPLES_SUCCESS,
  SAMPLE_POST_REQUEST,
  SAMPLE_POST_SUCCESS,
  SAMPLE_POST_FAILURE,

  INSERT_SAMPLE,
  REMOVE_SAMPLE_REQUEST,
  REMOVE_SAMPLE_SUCCESS,
  REMOVE_SAMPLE_FAILURE,
  DRAG_MARKER,
  DROP_MARKER,
  SET_ACTIVE_SAMPLEFORM,
  SET_ACTIVE_SAMPLEMARKER,
  SUBMISSION_REQUEST,
  SUBMISSION_SUCCESS,
  SUBMISSION_FAILURE,
  SET_ISNEWSAMPLE_FALSE
} from './samples-actions';

import { INITIALIZE, DESTROY } from 'redux-form/lib/actionTypes';

import { MODAL_SHOW_TUBEID } from '../Modal/modalActions';

// Initial Samples State
const initialState = {
  isFetching: false,
  isSubmitting: false,
  isPosting: false,
  errorMessage: null,
  byId: {},
  allIds: [],
  ui: {
    markers: [],
    activeSampleForm: '',
    isNewSample: false
  }
};

// Samples Reducer
function samplesReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case SAMPLES_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      });
    }
    case MODAL_SHOW_TUBEID: {
      return { ...state, errorMessage: null };
    }
    case INITIALIZE: {
      const mapMarkers = [...state.ui.markers,
        {
          active: false,
          processed: action.payload.processed,
          sampleId: action.payload.id,
          latitude: action.payload.latitude,
          longitude: action.payload.longitude
        }];

      return {
        ...state,
        allIds: [...state.allIds],
        byId: { ...state.byId },
        ui: {
          ...state.ui,
          markers: mapMarkers
        }
      };
    }
    case DESTROY: {
      const sampleIdList = action.meta.form.map(form => {
        return form.split('sample-')[1];
      });

      const newMarkers = state.ui.markers.filter(m => {
        return !sampleIdList.includes(m.sampleId);
      });

      return {
        ...state,
        allIds: [...state.allIds],
        byId: { ...state.byId },
        ui: {
          ...state.ui,
          markers: newMarkers
        }
      };
    }
    case SAMPLES_SUCCESS: {
      const byId = {};
      const allIds = [];
      action.samples.forEach(sample => {
        var newSampleObject = { ...sample };
        for (var property in sample) {
          if (sample[property] === null) {
            newSampleObject[property] = '';
          }
        }
        byId[sample.id] = { ...newSampleObject };
        allIds.push(sample.id);
      });
      return Object.assign({}, state, {
        isFetching: false,
        byId,
        allIds,
        ui: { ...state.ui, markers: [...state.ui.markers] }
      });
    }
    case REMOVE_SAMPLE_REQUEST: {
      return { ...state, isPosting: true };
    }
    case REMOVE_SAMPLE_SUCCESS: {
      const { sampleId } = action;
      if (state.allIds.find(item => item === sampleId)) {
        delete state.byId[sampleId];
        const newById = Object.assign({}, state.byId);
        const newMarkers = state.ui.markers.filter((marker) => (marker.sampleId !== sampleId));
        return {
          ...state,
          allIds: state.allIds.filter(item => item !== sampleId),
          byId: newById,
          ui: {
            ...state.ui,
            markers: newMarkers
          }
        };
      } else {
        return {
          ...state
        };
      }
    }

    case REMOVE_SAMPLE_FAILURE: {
      let msgString = null;
      switch (action.error.status) {
        case 401:
          msgString = '401';
          //msgString = action.error.data.message;
          break;
        case 400:
          msgString = '400';
          //msgString = action.error.data;
          break;
        case 409:
          msgString = action.error.data;
          break;
        default:
          msgString = '';
          break;
      }
      return { ...state, isPosting: false, errorMessage: msgString };
    }

    case DRAG_MARKER: {
      /*
        expect action.sampleId to be a string
        if this is a new sample, 
          expect there to be no marker where marker.sampleId === action.sampleId
          set all markers to active === false
          then push a new new marker with sampleId = action.sampleId and active = true;
          the new marker should be the only marker where active === true
        if this is an existing sample,
          expect there to be a marker with marker.sampleId === action.sampleId
          set that one to true and expect it is the only marker where active === true
      */
      var newMarkers = state.ui.markers.map((currentMarker) => {
        if (currentMarker.sampleId.toString() === action.sampleId.toString()) {
          currentMarker.active = true;
        } else {
          currentMarker.active = false;
        }
        return currentMarker;
      });

      if (newMarkers.every(marker => {
        return marker.active === false;
      }
      )) {
        newMarkers.push({ sampleId: action.sampleId, active: true });
      }
      return {
        ...state,
        ui: {
          ...state.ui,
          markers: newMarkers
        }
      };
    }
    case DROP_MARKER: {
      const newMarkers = state.ui.markers.filter((m) => {
        return m.sampleId !== action.marker.sampleId;
      })
        .map((marker) => {
          marker['active'] = false;
          return marker;
        })
        .concat(action.marker);
      /*
        expect newMarkers to have an entry === to action.marker
        expect all markers in newMarkers to have id, latitude, and lognitude
      */
      return {
        ...state,
        ui: {
          ...state.ui,
          markers: newMarkers
        }
      };
    }
    case SET_ACTIVE_SAMPLEMARKER: {
      var newmarkers = state.ui.markers.map(m => {
        m.active = (m.sampleId === action.sampleId) ? m.active = true : m.active = false;
        return m;
      });

      return {
        ...state,
        ui: {
          ...state.ui,
          markers: newmarkers,
        }
      };
    }
    case SET_ACTIVE_SAMPLEFORM: {
      // only set the form if the active sample has changed
      return {
        ...state,
        ui: {
          ...state.ui,
          activeSampleForm: action.formId
        }
      };
    }
    case SET_ISNEWSAMPLE_FALSE: {
      return {
        ...state,
        ui: {
          ...state.ui,
          isNewSample: false
        }
      };
    }
    case INSERT_SAMPLE:
      return state;
    //sample post reducers
    case SAMPLE_POST_REQUEST:
      return { ...state, isPosting: true };
    case SAMPLE_POST_FAILURE: {
      let  msgString = null;
      switch (action.error.status) {
        case 401:
          msgString = '401';
          //msgString = action.error.data.message;
          break;
        case 400:
          msgString = '400';
          //msgString = action.error.statusText;
          break;
        case 409:
          msgString = action.error.data;
          break;
        default:
          msgString = 'Error';
      }
      return { ...state, isPosting: false, errorMessage: msgString };
    }
    case SAMPLE_POST_SUCCESS: {
      var stringifiedSample = {};
      for (var property in action.sample) {
        stringifiedSample[property] = action.sample[property] === null ? '' : action.sample[property];
      }
      const allIds = state.allIds.indexOf(action.sample.id) > -1 ?
        [...state.allIds] 
        : [...state.allIds].concat(action.sample.id);
      const byId = {...state.byId, [action.sample.id]: stringifiedSample };
      return {
        ...state, 
        isPosting: false, 
        errorMessage: null, 
        byId, 
        allIds, 
        ui: {
          ...state.ui,
          isNewSample: action.isNewSample
        }
      };
    }

    //submission reducers

    case SUBMISSION_REQUEST:
      return { ...state, isSubmitting: true };

    case SUBMISSION_FAILURE:
      return { ...state, isSubmitting: false, errorMessage: action.error };

    case SUBMISSION_SUCCESS: {
      //the only thing that should change on submitted samples is date and UUID
      const byId = { ...state.byId };
      action.submission.forEach(sample => byId[sample.id] = { ...sample });
      return { ...state, isSubmitting: false, byId };
    }
    default: {
      return state;
    }
  }
}
export default samplesReducer;

export function getAssociatedMarker(store, sampleId) {
  const found = store.entities.samples.ui.markers.find(m => m.sampleId === sampleId);
  return found ? found : { latitude: null, longitude: null };
}

export function getActiveSampleForm(store) {
  return store.entities.samples.ui.activeSampleForm;
}

export function getMarkers(store) {
  return store.entities.samples.ui.markers;
}
